<template>
    <span v-if="item.status === 'finished'">
        <span class="ma-1 grey--text text--darken-4 caption" style="white-space: nowrap">
            {{ (item.finished_at ? item.finished_at : item.end) | format_date_short }}
        </span>
        <v-icon
            color="tretiary"
            size="22px"
        >
            mdi-check-circle
        </v-icon>
    </span>
    <span v-else>
        <span
            v-if="item.calc_status === 'overdue'"
            class="error--text font-weight-medium caption"
            style="white-space: nowrap"
        >
            {{ item.overdue_seconds | format_overdue(false) }}
        </span>
        <span
            v-else-if="item.status === 'in_progress'"
            class="grey--text text--darken-4 font-weight-medium caption"
            style="white-space: nowrap"
        >
            {{ $t("Ongoing") }}
        </span>
    </span>
</template>

<script>
export default {
    name: "RichDataTableTaskStatus",
    props: {
        item: {
            type: Object,
            default: null
        }
    }
};
</script>
